<template>
  <div class="col-md-3 col-12 my-2">
    <div v-if="external">
      <a :href="link" target="_blank">
        <conteudoBotao :titulo="titulo" :descricao="descricao" :image="image" :textoAlternativo="textoAlternativo"/>
      </a>
    </div>
    <div v-else-if="loginRequired">
      <button @click="funcao" class="w-100">
        <conteudoBotao :titulo="titulo" :descricao="descricao" :image="image" :textoAlternativo="textoAlternativo"/>
      </button>
    </div>
    <div v-else>
      <router-link :to="link">
        <conteudoBotao :titulo="titulo" :descricao="descricao" :image="image" :textoAlternativo="textoAlternativo"/>
      </router-link>
    </div>
  </div>
</template>

<script>
import conteudoBotao from './conteudoBotao.vue';

export default {
  name: "botaoTelaInicial",
  components: {
    conteudoBotao,
  },
  props: {
    titulo: {
      type: String,
      required: true,
    },
    descricao: {
      type: String,
      required: true,
    },
    textoAlternativo: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: false,
    },
    loginRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    external: {
      type: Boolean,
      required: false,
      default: false,
    },
    funcao: {
      type: Function,
      required: false,
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
}

button {
  border: none;
  cursor: pointer;
  outline: none;
}
</style>
